import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "../../../core/Icon";
export const RegisterSuccess = () => {
    return (React.createElement("div", { className: "process-master-challenge text-center" },
        React.createElement("div", null,
            React.createElement(Icon, { c: ['user', 64, 64, 'success-icon'] }),
            React.createElement("h1", { className: "mb-8" }, "Registrace dokon\u010Dena"),
            React.createElement("p", null, "Registrace je \u00FAsp\u011B\u0161n\u011B dokon\u010Dena, m\u016F\u017Eete pokra\u010Dovat na p\u0159ihla\u0161ovac\u00ED formul\u00E1\u0159."),
            React.createElement(Link, { className: "primary-button", to: "/cs/proces/prihlaseni-uzivatele" }, "P\u0159ihl\u00E1sit se"))));
};
